// extracted by mini-css-extract-plugin
module.exports = {"classNameRatingContainer":"styles_classNameRatingContainer__3eNr8"};